import {Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild} from '@angular/core';
import AirDatepicker from "air-datepicker";
import pl from "air-datepicker/locale/pl";
import {ModalController} from "@ionic/angular";
import {CommonUtils} from "../../utils/common";
import {DaySettings} from "../../models/day-settings.model";

@Component({
  selector: 'app-select-date',
  templateUrl: './select-date.component.html',
  styleUrls: ['./select-date.component.scss'],
})
export class SelectDateComponent implements OnInit {


  @ViewChild('dateInput') datepickerRef: ElementRef;
  private selectedDate: any;
  @Input()
  daysDefined: DaySettings[];
  @Input()
  minDate: Date;
  @Input()
  maxDate: Date;
  @Input()
  notModalMode: boolean;
  date: Date;

  @Input() title: string;

  @Output() dateSelectedEmitter = new EventEmitter<any>();
  private datepickerInstance: AirDatepicker<HTMLDivElement>;

  constructor(private renderer: Renderer2,
              private modalController: ModalController, private commonUtils: CommonUtils) {
  }

  getMaxDate() {
    const currentDate = new Date();
    if (this.maxDate) {
      return this.maxDate;
    } else {
      return currentDate.setFullYear(currentDate.getFullYear() + 1);
    }
  }

  getMinDate() {
    if (this.minDate) {
      return this.minDate;
    } else {
      return new Date();
    }
  }

  clearCurrentDate(): void {
    if (this.datepickerInstance) {
      this.datepickerInstance.clear();
    }
  }


  ngOnInit() {
    if (this.notModalMode) {
      setTimeout(() => {
        const datepicker = this.datepickerRef.nativeElement as HTMLDivElement;
        this.datepickerInstance = new AirDatepicker(datepicker, {
          range: false,
          locale: pl,
          minDate: new Date(),
          onSelect: ({date, formattedDate, datepicker}) => {
            if (date) {
              let s = this.commonUtils.dateTime2Str(date);
              this.selectedDate = s?.split(' ')[0];
              if (this.daysDefined && this.daysDefined.filter(e => e.day === this.selectedDate).length === 1) {
                this.commonUtils.presentAlertToast('Blokada na dany dzień została już skonfigurowana');
              } else {
                this.modalController.dismiss(this.selectedDate);
              }
            }
          }
        });
        const childrenIterator = datepicker.children[Symbol.iterator]();

        let child = childrenIterator.next().value;

        while (child) {
          this.renderer.setStyle(child, 'width', '100%');
          child = childrenIterator.next().value;
        }
      }, 0);
    } else {
      setTimeout(() => {
        const datepicker = this.datepickerRef.nativeElement as HTMLDivElement;
        this.datepickerInstance = new AirDatepicker(datepicker, {
          range: false,
          locale: pl,
          minDate: this.getMinDate(),
          maxDate: this.getMaxDate(),
          onSelect: ({date, formattedDate, datepicker}) => {
            if (date) {
              let s = this.commonUtils.dateTime2Str(date);
              this.selectedDate = s?.split(' ')[0];
              this.dateSelectedEmitter.emit(this.selectedDate);
            }
          }
        });
        const childrenIterator = datepicker.children[Symbol.iterator]();

        let child = childrenIterator.next().value;

        while (child) {
          this.renderer.setStyle(child, 'width', '100%');
          child = childrenIterator.next().value;
        }
      }, 0);
    }

  }

}
